module.exports = __webpack_public_path__ + "img/goldAppBj.c8e0e916.jpg";